import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Estimate, EstimateItems, EstimateWorkOrder, SendDownloadEstimate } from '../models/estimate.model';
import { CustomEstimateFieldValue } from '../models/estimate.model';
import { InvoiceAttachment } from '../models/invoice.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstimateService {
  private baseRoute: string;

  private mockEstimates: BehaviorSubject<Estimate[]>;
  private mockEstimateItems: BehaviorSubject<EstimateItems[]>;
  constructor(private httpClient: HttpClient) {
    this.mockEstimates = new BehaviorSubject<Estimate[]>([
      // { Id: '', CustomerId: 0, Balance: 0, DepositAmount: 0, EstimateNumber : '20191205000100001', Customer : 'Wolfgang Paganini', EstimateDate : new Date(), EstimateTotalAmount : 2000, Status : 'Viewed' },
      // { Id: '', CustomerId: 0, Balance: 0, DepositAmount: 0, EstimateNumber : '20191205000100002', Customer : 'Johannes Baethoven', EstimateDate : new Date(), EstimateTotalAmount : 0.00, Status : 'Paid' },
      // { Id: '', CustomerId: 0, Balance: 0, DepositAmount: 0, EstimateNumber : '20191205000100003', Customer : 'Ray Mendelbach', EstimateDate : new Date(), EstimateTotalAmount : 1250, Status : 'Past Due' },
      // { Id: '', CustomerId: 0, Balance: 0, DepositAmount: 0, EstimateNumber : '20191205000100004', Customer : 'Sam Dunn', EstimateDate : new Date(), EstimateTotalAmount : 600, Status : 'Sent' },
      // { Id: '', CustomerId: 0, Balance: 0, DepositAmount: 0, EstimateNumber : '20191205000100005', Customer : 'Clay Morrow', EstimateDate : new Date(), EstimateTotalAmount : 550, Status : 'Sent' },
    ]);

    this.mockEstimateItems = new BehaviorSubject<EstimateItems[]>([

    ])

  }


  getEstimates<T>(locationId: number, source: string):Observable<T>{
    return this.httpClient.get<T>(`${environment.estimatesAPIRoot}/getestimates?locationId=${locationId}&source=${source}`);
  }

  getEstimate<T>(estimateNumber : string):Observable<T>{
    return this.httpClient.get<T>(`${environment.estimatesAPIRoot}/getestimatebyestimatenumber/${estimateNumber}`);
  }

  deleteEstimateDetail<T>(estimateDetailId : number, updatedBy: number): Observable<T> {
    return this.httpClient.delete<T>(`${environment.estimatesAPIRoot}/detail/${estimateDetailId}/delete?updatedBy=${updatedBy}`);
  }

  addEstimateDetail<T>(estimateDetail : any): Observable<T> {
    return this.httpClient.post<T>(`${environment.estimatesAPIRoot}/addestimatedetails`, estimateDetail);
  }

  updateEstimateDetail<T>(estimateDetail : any): Observable<T> {
    return this.httpClient.put<T>(`${environment.estimatesAPIRoot}/updateestimatedetail`, estimateDetail);
  }

  // save manual invoice
  saveEstimate<T>(payload : Estimate) : Observable<T>{
    return this.httpClient.post<T>(`${environment.estimatesAPIRoot}/saveestimate`, payload);
  }

  // update manual invoice
  updateEstimate<T>(payload : Estimate) : Observable<T>{
    return this.httpClient.put<T>(`${environment.estimatesAPIRoot}/updateestimate`, payload);
  }
  sendEstimate<T>(payload: SendDownloadEstimate): Observable<T> {
    return this.httpClient.post<T>(`${environment.estimatesAPIRoot}/send`, payload);
  }

  getEstimateDetailsByEstimateNumber<T>(estimateNuber: string): Observable<T>{
    return this.httpClient.get<T>(`${environment.estimatesAPIRoot}/getestimatedetailsbyestimatenumber/${estimateNuber}`);
  }

  validateEstimateNumber<T>(estimateNumber: string): Observable<T> {
    return this.httpClient.get<T>(`${environment.estimatesAPIRoot}/${estimateNumber}/validate`);
  }

  generateEstimateNumber<T>(): Observable<T>{
    return this.httpClient.get<T>(`${environment.estimatesAPIRoot}/generateestimatenumber`);
  }


  getEstimateManualInvoice<T>(estimateNuber: string): Observable<T>{
    return this.httpClient.get<T>(`${environment.estimatesAPIRoot}/getestimatemanualinvoice/${estimateNuber}`);
  }

  addManualInvoice<T>(estimateNumber: string, invoiceNumber: string): Observable<T> {
    return this.httpClient.post<T>(`${environment.estimatesAPIRoot}/addmanualinvoice/${estimateNumber}/${invoiceNumber}`, null);
  }

  deleteEstimate<T>(estimateNumber : string, updatedBy: number): Observable<T> {
    return this.httpClient.delete<T>(`${environment.estimatesAPIRoot}/deleteestimate/${estimateNumber}/${updatedBy}`);
  }

  upsertEstimateWorkorder<T>(payload : EstimateWorkOrder) : Observable<T>{
    return this.httpClient.post<T>(`${environment.estimatesAPIRoot}/upsertestimateworkorder`, payload);
  }

  getEstimateWorkOrder<T>(estimateNuber: string): Observable<T>{
    return this.httpClient.get<T>(`${environment.estimatesAPIRoot}/getestimateworkorder/${estimateNuber}`);
  }

  getWorkOrder<T>(workOrderId: string): Observable<T> {
    return this.httpClient.get<T>(`${environment.serviceworkorderAPIRoot}/main/get/${workOrderId}`);
  }

  getEstimateLineItems<T>(estimateNumber: string): Observable<T> {
    // return this.httpClient.get<T>(`${this.baseRoute}/getmanualinvoicedetailsbyinvoicenumber/${invoiceNumber}`);
    return this.httpClient.get<T>(`${environment.estimatesAPIRoot}/getestimatedetailsbyestimatenumber/${estimateNumber}`);
  }

  markEstimateAsAccepted<T>(estimateNumber : any): Observable<T> {
    return this.httpClient.post<T>(`${environment.estimatesAPIRoot}/markasaccepted/${estimateNumber}`, null);
  }

  markEstimateAsAcceptedForWorkOrder<T>(estimateNumber : any): Observable<T> {
    return this.httpClient.post<T>(`${environment.estimatesAPIRoot}/markasacceptedforworkorder/${estimateNumber}`, null);
  }

  markEstimateAsViewed<T>(estimateNumber : any): Observable<T> {
    return this.httpClient.post<T>(`${environment.estimatesAPIRoot}/markasviewed/${estimateNumber}`, null);
  }

  getAllCustomFieldValuesByEstimateNumber<T>(estimateNumber: string): Observable<T> {
    return this.httpClient.get<T>(`${environment.estimatesAPIRoot}/getallcustomfieldvaluesbyestimatenumber/${estimateNumber}`);
  }

  upsertEstimateCustomFieldValues<T>(fields: CustomEstimateFieldValue[]): Observable<T> {
    return this.httpClient.post<T>(`${environment.estimatesAPIRoot}/upsertestimatecustomfieldvalues`, fields);
  }

  getEstimateDocuments(estimateNumber: any): Observable<InvoiceAttachment> {
    return this.httpClient.get<InvoiceAttachment>(
      `${environment.estimatesAPIRoot}/getestimatedocumentbyestimatenumber/${estimateNumber}`
    );
  }

  deleteEstimateDocument<T>(
    docId: number,
    updatedBy: number,
    estimateNumber: string
  ): Observable<T> {
    return this.httpClient.delete<T>(
      `${environment.estimatesAPIRoot}/deleteestimatedocument/${docId}/${updatedBy}/${estimateNumber}`
    );
  }
}
